/* Gaucho House · fade-in de títulos (solo textos)
 * Parte cada título en sus líneas reales (con máscara) y las hace subir al entrar en pantalla.
 * Con "Secuencia", el eyebrow y el párrafo de apoyo entran en orden con un fade corto.
 * Preset de tiempo: URL (?gh-motion=lento) → localStorage → setting del tema (lo resuelve el <head>).
 * Panel de ajuste: solo con ?gh-motion-debug=1. No anima imágenes, botones ni campos.
 * La lógica de partir líneas viene de motion-lab/js/lab.js (Lab.splitLines / Lab.autoSplit),
 * adaptada para conservar los elementos internos del título (.gh-heading__line, <em>).
 */
(function () {
  var root = document.documentElement;
  var raw = root.getAttribute('data-gh-cfg');
  if (!raw) return;                       // editor del tema, sin IntersectionObserver o apagado desde el <head>
  var cfg;
  try { cfg = JSON.parse(raw); } catch (e) { return; }

  var DEBUG = /(?:^|[?&])gh-motion-debug=1(?:&|$)/.test(location.search);
  if (cfg.preset === 'off' && !DEBUG) return;

  /* Selectores: tienen que coincidir con assets/gh-motion.css */
  var TITLE_SELECTORS = [
    '.gh-heading',            // títulos de sección (snippet gh-section-heading): hero, historia, colecciones, diseños,
                              // field to polo, best sellers, materiales, elaboración, asado, testimonios, galería,
                              // newsletter, y los de producto / carrito
    '.gh-kbanner__title',     // h1 de las páginas FAQ y Contact
    '.gh-cbanner__title',     // h1 de colección
    '.gh-sbanner__title',     // h1 de búsqueda
    '.gh-404__title',         // h1 del 404
    '.gh-faq__group-title',   // grupos de la FAQ
    '.gh-faq__cta-title',     // cierre de la FAQ
    '.gh-csize__title'        // ayuda de talles de la colección
  ];
  var EYEBROW = ['.gh-kbanner__eyebrow', '.gh-cbanner__eyebrow', '.gh-404__eyebrow'];
  var BODY = [
    '.gh-hero__text', '.gh-story__greeting', '.gh-story__letter', '.gh-collections__description',
    '.gh-materials__description', '.gh-field__text', '.gh-asado__text', '.gh-newsletter__text',
    '.gh-dstory__story', '.gh-kbanner__text', '.gh-cbanner__description', '.gh-404__text', '.gh-pdetails__text'
  ];
  var EXCLUDE = 'header, footer, cart-drawer, dialog, [role="dialog"], [aria-modal="true"], [popover], ' +
                '.card, .product-card, .gh-product-card';
  var PRESETS = {
    rapido: { dur: 500, stagger: 80 },
    medio: { dur: 800, stagger: 130 },
    lento: { dur: 1200, stagger: 180 }
  };

  var titles = [], claims = new Map(), scanned = false, failed = false, io = null;
  var panelRefresh = function () {};

  /* ------------------------------------------------------------------ tiempos */
  function apply(c) {
    cfg = Object.assign(cfg, c || {});
    var p = PRESETS[cfg.preset] || PRESETS.medio;
    root.style.setProperty('--gh-dur', (cfg.dur != null ? cfg.dur : p.dur) + 'ms');
    root.style.setProperty('--gh-stagger', (cfg.stagger != null ? cfg.stagger : p.stagger) + 'ms');
    root.toggleAttribute('data-gh-seq', !!cfg.seq);
    if (cfg.preset === 'off') root.classList.remove('gh-motion-on');
    else if (!failed) { root.classList.add('gh-motion-on'); if (!scanned) start(); }
    panelRefresh();
  }
  function current() {
    var p = PRESETS[cfg.preset] || PRESETS.medio;
    return {
      preset: cfg.preset,
      dur: cfg.dur != null ? cfg.dur : p.dur,
      stagger: cfg.stagger != null ? cfg.stagger : p.stagger,
      seq: !!cfg.seq
    };
  }

  /* ------------------------------------------------------------ partir líneas */
  // Hosts donde se parte: cada .gh-heading__line si es un bloque; si son en línea (p. ej. hero en mobile
  // o "Best sellers"), el título entero. Así los selectores de hermanos del CSS del tema siguen valiendo.
  function hostsOf(el) {
    var ls = [].filter.call(el.children, function (c) { return c.classList.contains('gh-heading__line'); });
    if (ls.length && ls.every(function (c) { return getComputedStyle(c).display === 'block'; })) return ls;
    return [el];
  }

  function wordsOf(host) {
    var words = [];
    function add(text, owner) {
      text.split(/\s+/).forEach(function (w) { if (w) words.push({ t: w, o: owner }); });
    }
    for (var i = 0; i < host.childNodes.length; i++) {
      var n = host.childNodes[i];
      if (n.nodeType === 3) add(n.textContent, null);
      else if (n.nodeType === 1) {
        if (/^(BR|IMG|SVG|VIDEO|CANVAS|INPUT|BUTTON|SELECT|TEXTAREA)$/i.test(n.tagName)) return null;
        add(n.textContent, n);
      }
    }
    return words;
  }

  // Arma los nodos de una lista de palabras conservando el elemento "dueño" (<em>, .gh-heading__line)
  function build(words, parent, wrap) {
    var run = null, node = null;
    words.forEach(function (w, k) {
      if (k && (!run || run.o !== w.o)) parent.appendChild(document.createTextNode(' '));
      if (!run || run.o !== w.o) {
        run = { o: w.o };
        node = w.o ? w.o.cloneNode(false) : null;
        if (node) parent.appendChild(node);
      } else {
        (node || parent).appendChild(document.createTextNode(' '));
      }
      (node || parent).appendChild(wrap(w));
    });
  }

  function splitHost(host, start) {
    var words = wordsOf(host);
    if (words === null) {                       // contenido raro (imagen, br): se anima como una sola línea
      var ln = document.createElement('span'), inn = document.createElement('span');
      ln.className = 'gh-line'; ln.setAttribute('aria-hidden', 'true'); inn.className = 'gh-line-in';
      inn.style.setProperty('--i', start);
      while (host.firstChild) inn.appendChild(host.firstChild);
      ln.appendChild(inn); host.appendChild(ln);
      return 1;
    }
    if (!words.length) return 0;

    // 1. medir: cada palabra en su propio inline-block, con el mismo estilo que tendrá
    host.textContent = '';
    var spans = [];
    build(words, host, function (w) {
      var s = document.createElement('span');
      s.style.display = 'inline-block'; s.textContent = w.t; spans.push(s);
      return s;
    });
    var lines = [], top = null;
    spans.forEach(function (s, i) {
      var t = s.offsetTop;
      if (top === null || Math.abs(t - top) > 4) { lines.push([]); top = t; }
      lines[lines.length - 1].push(words[i]);
    });

    // 2. rearmar: una máscara por línea
    host.textContent = '';
    lines.forEach(function (lw, k) {
      var ln = document.createElement('span'), inn = document.createElement('span');
      ln.className = 'gh-line'; ln.setAttribute('aria-hidden', 'true');
      inn.className = 'gh-line-in'; inn.style.setProperty('--i', start + k);
      build(lw, inn, function (w) { return document.createTextNode(w.t); });
      ln.appendChild(inn); host.appendChild(ln);
    });
    return lines.length;
  }

  function split(el) {
    if (el.__ghOrig == null) el.__ghOrig = el.innerHTML;
    else { el.innerHTML = el.__ghOrig; el.classList.remove('gh-host'); }   // siempre se parte desde el contenido original
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    el.setAttribute('aria-label', text);        // los lectores de pantalla leen el título completo
    var i = 0;
    hostsOf(el).forEach(function (h) {
      var block = getComputedStyle(h).display === 'block';
      i += splitHost(h, i);
      // columna flex: los márgenes negativos de .gh-line no se colapsan (se agrega recién después de medir)
      if (block) h.classList.add('gh-host');
    });
    el.__ghW = el.clientWidth;
    el.classList.add('gh-ready');
  }

  /* ------------------------------------------------------------------- escaneo */
  function claim(title) {
    // El eyebrow y el párrafo de la misma sección: se busca en el contenedor más grande que
    // tenga este único título (así un párrafo no se "roba" por otro título de la misma sección).
    var sel = TITLE_SELECTORS.join(','), nodes = [], box = title.parentElement, best = null;
    var stop = title.closest('section, .shopify-section') || document.body;
    while (box) {
      var inside = box.querySelectorAll(sel);
      var own = [].filter.call(inside, function (t) { return !t.closest(EXCLUDE); });
      if (own.length > 1) break;
      best = box;
      if (box === stop) break;
      box = box.parentElement;
    }
    if (best) {
      best.querySelectorAll(EYEBROW.concat(BODY).join(',')).forEach(function (n) {
        if (!n.hasAttribute('data-gh-fade') && !n.closest(EXCLUDE)) nodes.push(n);
      });
    }
    nodes.forEach(function (n) { n.setAttribute('data-gh-fade', ''); });
    return nodes;
  }

  var SEL = TITLE_SELECTORS.join(','), FADE_SEL = EYEBROW.concat(BODY).join(',');

  function consider(el) {
    if (el.hasAttribute('data-gh-title') || el.closest(EXCLUDE) || !el.textContent.trim()) return;
    el.setAttribute('data-gh-title', '');
    titles.push(el);
    claims.set(el, claim(el));
    if (el.getClientRects().length) split(el);   // si está oculto (display:none) se parte al mostrarse
    io.observe(el);
  }

  // Eyebrow / párrafo sin título asignado: nunca quedan escondidos
  function release(scope) {
    var list = scope.querySelectorAll ? [].slice.call(scope.querySelectorAll(FADE_SEL)) : [];
    if (scope.matches && scope.matches(FADE_SEL)) list.push(scope);
    list.forEach(function (n) {
      if (!n.hasAttribute('data-gh-fade') && !n.closest(EXCLUDE)) { n.classList.add('gh-in', 'gh-static'); n.setAttribute('data-gh-fade', ''); }
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches(SEL)) consider(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(SEL).forEach(consider);
    release(scope);
  }

  // Secciones que se cargan después (recomendaciones, filtros, section rendering): también se parten
  function watchDom() {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function enter(t) {
    // Si cambió el ancho mientras estaba oculto, se vuelve a partir antes de animar
    if (!t.classList.contains('gh-ready') || (t.clientWidth && t.__ghW !== t.clientWidth)) {
      split(t); void t.offsetWidth;
    }
    var seq = root.hasAttribute('data-gh-seq');
    t.style.setProperty('--gh-base', seq ? 'var(--gh-seq-title)' : '0ms');
    (claims.get(t) || []).forEach(function (n) {
      var eye = EYEBROW.some(function (s) { return n.matches(s); });
      n.style.setProperty('--gh-base', seq ? (eye ? '0ms' : 'var(--gh-seq-body)') : '0ms');
      if (!seq) n.classList.add('gh-static');
      n.classList.add('gh-in');
    });
    t.classList.add('gh-in');
  }

  function start() {
    if (scanned) return;
    scanned = true;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        enter(e.target);
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
    (document.fonts && document.fonts.ready || Promise.resolve()).then(function () {
      scan(document);
      root.classList.add('gh-ready-all');
      watchDom();
    });
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (!scanned) return;
      titles = titles.filter(function (el) { return el.isConnected; });
      titles.forEach(function (el) { if (el.getClientRects().length) split(el); });   // las líneas dependen del ancho
    }, 250);
  });

  function replay() {
    if (!scanned || !io) return;
    titles = titles.filter(function (el) { return el.isConnected; });
    root.classList.add('gh-reset');
    titles.forEach(function (t) {
      t.classList.remove('gh-in'); io.unobserve(t);
      (claims.get(t) || []).forEach(function (n) { n.classList.remove('gh-in', 'gh-static'); });
    });
    void root.offsetWidth;
    root.classList.remove('gh-reset');
    titles.forEach(function (t) { io.observe(t); });
  }

  /* ---------------------------------------------------- salvaguarda y arranque */
  // Si algo tarda más de 3 s, el <head> ya quitó la clase: acá solo se evita volver a prenderla.
  setTimeout(function () { if (!root.classList.contains('gh-ready-all')) failed = true; }, 3000);

  function save(o) {
    try {
      if (o.preset) { localStorage.setItem('gh-motion', o.preset); }
      if (o.custom === null) localStorage.removeItem('gh-motion-custom');
      else if (o.custom) {
        var c = JSON.parse(localStorage.getItem('gh-motion-custom') || '{}');
        localStorage.setItem('gh-motion-custom', JSON.stringify(Object.assign(c, o.custom)));
      }
    } catch (e) {}
  }

  /* --------------------------------------------------------------------- panel */
  function panel() {
    var el = document.createElement('aside');
    el.className = 'gh-mdbg'; el.setAttribute('aria-label', 'Ajuste de motion');
    el.innerHTML =
      '<div class="gh-mdbg__head"><strong>Motion · títulos</strong>' +
      '<button type="button" class="is-primary" data-a="replay">Repetir</button>' +
      '<button type="button" data-a="toggle" aria-label="Mostrar u ocultar el panel">–</button></div>' +
      '<div class="gh-mdbg__body">' +
      '<div class="gh-mdbg__presets">' +
      ['rapido', 'medio', 'lento', 'off'].map(function (p) { return '<button type="button" data-p="' + p + '">' + (p === 'rapido' ? 'rápido' : p) + '</button>'; }).join('') +
      '</div>' +
      '<label class="gh-mdbg__row gh-mdbg__row--check"><span>Secuencia (eyebrow, título, párrafo)</span><input type="checkbox" data-a="seq"></label>' +
      '<label class="gh-mdbg__row"><span>Duración por línea</span><output data-o="dur"></output><input type="range" min="300" max="2000" step="50" data-a="dur"></label>' +
      '<label class="gh-mdbg__row"><span>Escalonado entre líneas</span><output data-o="stagger"></output><input type="range" min="0" max="300" step="10" data-a="stagger"></label>' +
      '<p class="gh-mdbg__read" data-o="read"></p>' +
      '</div>';
    document.body.appendChild(el);

    var q = function (s) { return el.querySelector(s); };
    panelRefresh = function () {
      var c = current();
      el.querySelectorAll('[data-p]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-p') === c.preset)); });
      q('[data-a="seq"]').checked = c.seq;
      q('[data-a="dur"]').value = c.dur; q('[data-o="dur"]').textContent = c.dur + ' ms';
      q('[data-a="stagger"]').value = c.stagger; q('[data-o="stagger"]').textContent = c.stagger + ' ms';
      q('[data-o="read"]').textContent =
        'preset: ' + c.preset + ' · duración: ' + c.dur + ' ms · escalonado: ' + c.stagger + ' ms · secuencia: ' + (c.seq ? 'sí' : 'no') +
        '  →  ?gh-motion=' + c.preset + '&gh-seq=' + (c.seq ? 1 : 0);
    };

    el.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.p) {
        apply({ preset: b.dataset.p, dur: null, stagger: null });
        save({ preset: b.dataset.p, custom: null });
        save({ custom: { seq: !!cfg.seq } });
        replay();
      } else if (b.dataset.a === 'replay') replay();
      else if (b.dataset.a === 'toggle') el.classList.toggle('is-closed');
    });
    el.addEventListener('input', function (e) {
      var a = e.target.getAttribute('data-a');
      if (a === 'dur') { apply({ dur: +e.target.value }); save({ custom: { dur: +e.target.value } }); }
      else if (a === 'stagger') { apply({ stagger: +e.target.value }); save({ custom: { stagger: +e.target.value } }); }
    });
    el.addEventListener('change', function (e) {
      var a = e.target.getAttribute('data-a');
      if (a === 'seq') { apply({ seq: e.target.checked }); save({ custom: { seq: e.target.checked } }); replay(); }
      else if (a === 'dur' || a === 'stagger') replay();
    });
    panelRefresh();
  }

  window.GHMotion = { apply: apply, replay: replay, current: current };
  apply({});
  if (DEBUG) {
    if (document.body) panel(); else document.addEventListener('DOMContentLoaded', panel);
  }
})();
